import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

function SummaryCards({ summary }) {
  const { t } = useTranslation();

  if (!summary) return null;

  const needsUpdate = (summary.outdated || 0) + (summary.no_data || 0);

  const cards = [
    { label: t('sectorsManagement.summary.totalSectors'), value: summary.total, color: '#3b82f6' },
    { label: t('sectorsManagement.summary.withMapping'), value: summary.with_mapping, color: '#059669' },
    { label: t('sectorsManagement.summary.withData'), value: summary.with_data, color: '#0891b2' },
    { label: t('sectorsManagement.summary.needsUpdate'), value: needsUpdate, color: needsUpdate > 0 ? '#dc2626' : '#6b7280' },
  ];

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 1fr)' },
      gap: 1.5, mb: 2,
    }}>
      {cards.map((card, idx) => (
        <Box key={idx} sx={{
          p: 2, bgcolor: 'background.paper',
          border: '1px solid', borderColor: 'divider', borderRadius: 2.5,
        }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', fontWeight: 600 }}>
            {card.label}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700, mt: 0.5, color: card.color, fontFeatureSettings: '"tnum"' }}>
            {card.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default SummaryCards;

